import { render, staticRenderFns } from "./labelSub.vue?vue&type=template&id=ae270d12&scoped=true"
import script from "./labelSub.vue?vue&type=script&lang=js"
export * from "./labelSub.vue?vue&type=script&lang=js"
import style0 from "./labelSub.vue?vue&type=style&index=0&id=ae270d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae270d12",
  null
  
)

export default component.exports